module.exports = __webpack_public_path__ + "img/chile.3689975f.png";